var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 120,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_333)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0408 11.7352C26.3798 11.7352 11.25 26.865 11.25 45.5316C11.25 60.4617 20.932 73.1278 34.3617 77.5983C36.052 77.9077 36.668 76.8642 36.668 75.9671C36.668 75.1669 36.6398 73.0406 36.623 70.2211C27.2222 72.263 25.2394 65.6902 25.2394 65.6902C23.7023 61.7878 21.4861 60.7486 21.4861 60.7486C18.4177 58.6505 21.7181 58.6927 21.7181 58.6927C25.11 58.9331 26.8945 62.176 26.8945 62.176C29.9095 67.3397 34.8047 65.8477 36.7298 64.9842C37.0378 62.8003 37.9083 61.3111 38.8758 60.466C31.372 59.6138 23.4816 56.7127 23.4816 43.7639C23.4816 40.0753 24.7992 37.0575 26.9606 34.695C26.6133 33.84 25.4531 30.4045 27.2911 25.7513C27.2911 25.7513 30.1289 24.8428 36.585 29.2163C39.2808 28.4667 42.172 28.0913 45.045 28.0786C47.9152 28.0913 50.8064 28.4667 53.5064 29.2163C59.9583 24.8428 62.7905 25.7513 62.7905 25.7513C64.6341 30.4045 63.4739 33.84 63.1266 34.695C65.2922 37.0575 66.6014 40.0753 66.6014 43.7639C66.6014 56.7464 58.6983 59.6025 51.1692 60.4392C52.3842 61.4827 53.4642 63.5442 53.4642 66.6985C53.4642 71.2153 53.4234 74.8603 53.4234 75.9671C53.4234 76.8727 54.0309 77.9246 55.7466 77.5941C69.165 73.1152 78.8386 60.4575 78.8386 45.5316C78.8386 26.865 63.7073 11.7352 45.0408 11.7352Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.dae337d3690bb8ad2caf0d6b6b921e94.svg";
export { ForwardRef as ReactComponent };